if(!customElements.get('search-drawer')){
    class SearchDrawer extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.searchInput = this.querySelector('input[name="q"]');

            // open drawer by clicking icon
            document.querySelectorAll('.search-icon').forEach(item => {
                const action = item.dataset.action;
                const object = item.dataset.object;

                if(action == 'open' && object == 'search'){
                    item.addEventListener('click', (e) => {
                        this.openDrawer(e, item);
                    });
                }
            });

            // close drawer
            this.addEventListener('click', this.onDrawerClick.bind(this));
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closeDrawer.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter') this.closeDrawer();
                });
            });
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE'){
                    this.closeDrawer();
                }
            });

            // predictive search
            this.predictiveSearch = this.querySelector('.predictive-search-content');
            if(this.predictiveSearch){
                this.predictiveSearchHTML = this.querySelector('#predictive-search');
                this.loadingBar = this.querySelector('#predictive-search-loading-bar');

                this.showVendor = this.predictiveSearchHTML.dataset.showVendor;
                this.showPrice = this.predictiveSearchHTML.dataset.showPrice;
                this.numItems = this.predictiveSearchHTML.dataset.numItems;
                this.initialContent = this.querySelector('.search-drawer-initial-content');
                this.predictiveSearchContent = this.querySelector('.predictive-search-content');

                this.searchInput.addEventListener("focus", this.activeInput.bind(this));
                this.searchInput.addEventListener('blur', this.activeInput.bind(this));
                this.searchInput.addEventListener('input', this.debounce((e) => {
                    this.loadingBar.setAttribute('aria-hidden', 'false');
                    this.predictiveSearchContent.setAttribute('aria-hidden', 'false');
                    
                    if(this.initialContent){
                        this.initialContent.setAttribute('aria-hidden', 'true');
                    }
                    this.predictiveSearchHTML.innerHTML = ''; // clear search result

                    this.onChangeSearchInput(e);
                    this.activeInput();
                }, 300).bind(this));
            }
        }

        activeInput(){
            const searchInputForm = this.querySelector('#search-form');
            if(!searchInputForm) return;

            if(document.activeElement === this.searchInput || this.searchInput.value.trim()){
                searchInputForm.classList.add('active');
            }else{
                searchInputForm.classList.remove('active');
            }
        }

        onChangeSearchInput(e){
            const searchTerm = this.searchInput.value.trim();

            if(!searchTerm.length) {
                this.closeSearchResult();
                return;
            }

            this.getSearchResults(searchTerm);
        }

        getSearchResults(searchTerm){
            fetch(`/search/suggest?q=${searchTerm}&resources[limit]=${parseInt(this.numItems)}&section_id=predictive-search&resources[limit_scope]=each`)
            .then((response) => {
                if(!response.ok){
                    var error = new Error(response.status);
                    this.closeSearchResult();
                    throw error;
                }

                return response.text();
            }).then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchHTML.innerHTML = resultsMarkup;

                this.predictiveSearchContent.setAttribute('aria-hidden', 'false');
                this.loadingBar.setAttribute('aria-hidden', 'true');
                this.predictiveSearchHTML.setAttribute('aria-hidden', 'false');

                this.updateSuggestionTerms();
            }).catch(error => {
                this.closeSearchResult();
                throw error;
            });
        }

        updateSuggestionTerms(){
            this.querySelectorAll('.suggested-terms').forEach(item => {
                const title = item.dataset.title;
                const searchTerm = item.dataset.term;

                if(!title) return;
                if(!searchTerm) return;

                const regex = new RegExp(`(${searchTerm})`, 'ig'); // case-insensitive
                item.innerHTML = title.replace(regex, '<strong>$1</strong>');
            });
        }


        closePredictiveSearchResult(){
            this.loadingBar.setAttribute('aria-hidden', 'false');
            this.predictiveSearchHTML.setAttribute('aria-hidden', 'true');
            this.predictiveSearchContent.setAttribute('aria-hidden', 'true');
        }

        closeSearchResult(){
            if(this.predictiveSearch){
                this.closePredictiveSearchResult();
            }

            if(this.initialContent){
                this.initialContent.setAttribute('aria-hidden', 'false');
            }
        }

        debounce(fn, wait){
            let t;
            return (...args) => {
              clearTimeout(t);
              t = setTimeout(() => fn.apply(this, args), wait);
            }
        }

        openDrawer(e, triggerElement){
            if(e) e.preventDefault();

            this.previouslyFocusedElement = triggerElement || document.activeElement;

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            FocusTrap.activate(this);
            this.addFocus();
        }

        addFocus(){
            if(this.searchInput){
                setTimeout(() => {
                    this.searchInput.focus();
                }, 100);
            }
        }

        closeDrawer(){
            FocusTrap.deactivate(this);

            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }

        onDrawerClick(e){
            const isDrawerClicked = e.target === e.currentTarget;
            if(isDrawerClicked){
                this.closeDrawer();
            }
        }

    }

    customElements.define('search-drawer', SearchDrawer);
}
